module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAAACXBIWXMAABCcAAAQnAEmzTo0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAENSURBVHgB1ZXhDYIwEIUPw39xgzKBbiAjsIITqCM4gW6gI7iBuoEbWDfACeq7UGIh0B4STPySl4a2ebTX3pVoRKLQBGOMIgFRFGmSwqbQw8jhuQvXI/b4Z5CCNPQkP1OIjdfQSmKubLvDlk+eebzLDM2l2R83JiVocvs5t+0S/W2eBX56Jik9Y8zsq5Xb76PrN3GMFX1CISX3DU5oREY1990WDW2hwulTEMc5oYHm97bbUB3iUPOcb09Lv2jVIXNG0QB8B3qDZggNF7eUyjPohW/lnJaJzdouuLi56ftqdyqr4Ddoq6tplOdQzENoRC3tGvxZhhZUTxgJ3jpfe+ZszDYku8u8kEOv5+1veAPtzfMzP3wGkgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/Images/copyiocns.png
// module id = 1116
// module chunks = 0